import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";
import moment from "moment";
import _ from "lodash";

// icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";

// components
import EmptyComponent from "../../../components/EmptyComponent";
import CustomButton from "../../../components/CustomButton";
import {
  errorSwal,
  successDeleteSwal,
  successSwal,
  successUpdateSwal,
} from "../../../helper/sweetalert";
import { USER_KEY } from "../../../const";
import { LaoAddress } from "../../../const/laoAddress";
import AnimationLoading from "../../../components/Animationloading";

// apollo
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_USER_CONFIRM } from "../../../apollo/userconfirm/query";
import {
  CREATE_USER_CONFIRM,
  DELETE_USER_CONFIRM,
  UPDATE_USER_CONFIRM,
} from "../../../apollo/userconfirm/mutation";

// react bootrap
import { Table, Form, Modal, Spinner, InputGroup, Container, Row, Col } from "react-bootstrap";
import PaginationHelper from "../../../components/PaginationHelper";
import ComfirmModal from "../../../components/ComfirmModal";
import UserTypeManage from "./UserTypeManage";
import { GET_USER_TYPE } from "../../../apollo/userType/mutation";
import { ReactIcons } from "../../../icons";

export default function Customer() {
  const history = useHistory();
  const [userConfirm, setUserConfirm] = useState();
  const [userconfirmTotal, setUserConfirmTotal] = useState();
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [actionMode, setActionMode] = useState({
    mode: false,
    open: false,
    data: null
  });
  const [searchCustomer, setSearchCustomer] = useState();
  const [editUserType, setEditUserType] = useState("");
  const [selectUserType, setSelectUserType] = useState("");
  const [newUserTypeData, setNewUserTypeData] = useState();
  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  const [userTypeModal, setUserTypeModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState({ start: '', end: '' });

  // ======== Query And Mutation ==========

  const [getuserConfirm, { data: getuserConfirmData, loading }] = useLazyQuery(
    GET_USER_CONFIRM,
    { fetchPolicy: "cache-and-network" }
  );
  const [createUserConfirm, { loading: loadingCreate }] =
    useMutation(CREATE_USER_CONFIRM);
  const [deleteUserConfirm, { loading: loadingDelete }] =
    useMutation(DELETE_USER_CONFIRM);
  const [updateUserConfirm, { loading: loadingUpdate }] =
    useMutation(UPDATE_USER_CONFIRM);
  const [userTypeData, { data: getUserTypeData, loading: getUserTypeLoading }] =
    useLazyQuery(GET_USER_TYPE, { fetchPolicy: "cache-and-network" });

  // ======== useEffect ==========

  useEffect(() => {
    if (getuserConfirmData) {
      setUserConfirm(getuserConfirmData?.userconfirms?.data);
      setUserConfirmTotal(getuserConfirmData?.userconfirms?.total);
    }
  }, [getuserConfirmData]);
  
  useEffect(() => {
    if (actionMode.data) {
      setEditUserType(actionMode.data?.userType?.id || "");
    }
  }, [actionMode.data]);

  // useEffect(() => {
  //   fetchUserType();
  //   _filter();
  // }, []);

  useEffect(() => {
    _filter();
    fetchUserType();
  }, [searchCustomer, selectedDate, selectUserType]);

  useEffect(() => {
    if (!_.isEmpty(getUserTypeData?.getUserTypes)) {
      const data = getUserTypeData?.getUserTypes.filter((item) => item?.isOpen);
      setNewUserTypeData(data);
    }
  }, [getUserTypeData?.getUserTypes]);


  // ======== Fuction ==========

  const fetchUserType = async () => {
    try {
      if (getUserTypeLoading || newUserTypeData) return;
      await userTypeData();
    } catch (error) {
      console.log("error fetch user type")
    }
  }

  const _createUser = async (values) => {
    try {
      if (loadingCreate) return;
      if (!values.name) {
        errorSwal("ກະລຸນາເພີ່ມຂໍ້ມູນ...");
        return;
      }
      if (_.isEmpty(values?.userType)) {
        values = { ...values, userType: newUserTypeData[0]?.id };
      }
      await createUserConfirm({
        variables: {
          data: {
            ...values,
            phone: values?.phone.toString(),
            shop: shopId
          },
        },
      });
      successSwal("ເພີ່ມສຳເລັດ");
      cleanAction();
      await _filter();
    } catch (err) {
      errorSwal("ລາຍຊື່ລູກຄ້ານີ້ມີຢູ່ແລ້ວ");
      // console.log('error creating todo:', err)
    }
  };

  // <============== Update Unit =================>

  const _updateUerConfirm = async (values) => {
    try {
      if (loadingUpdate) return;
      if (_.isEmpty(values?.userType) && !actionMode.data?.userType?.id) {
        values = { ...values, userType: newUserTypeData[0]?.id };
      }
      const value = {
        variables: {
          where: {
            id: actionMode?.data?.id,
          },
          data: {
            ...values,
            phone: values?.phone.toString(),
          },
        }
      }
      await updateUserConfirm(value);
      _filter();
      successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      cleanAction();
    } catch (err) {
      errorSwal("ລາຍຊື່ລູກຄ້ານີ້ມີຢູ່ແລ້ວ");
    }
  };
  const cleanAction = () => {
    setActionMode({
      mode: false,
      open: false,
      data: null
    });
  }

  // ======== Fuction Delete ==========

  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");
  const handleShowDelete = (id, name) => {
    setDelete({ id, name });
    setShowDelete(true);
  };

  const _confirmeDelete = async () => {
    try {
      if (loadingDelete) return;
      await deleteUserConfirm({
        variables: {
          where: {
            id: Delete?.id,
          },
        },
      });
      _filter();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
    }
  };

  const _filter = async () => {
    try {
      let _where = {
        isDeleted: false,
      };

      // TODO: check if search text is not empty
      if (!_.isEmpty(searchCustomer)) {
        _where = {
          ..._where,
          searchKeyWord: searchCustomer,
        };
      }

      // TODO: select user type
      if (!_.isEmpty(selectUserType)) {
        _where = { ..._where, userType: selectUserType };
      }

      // TODO: select date
      if (!_.isEmpty(selectedDate.start) && !_.isEmpty(selectedDate.end)) {
        _where = { ..._where, createdAt_gte: selectedDate.start };
        _where = { ..._where, createdAt_lt: selectedDate.end };
      }

      // TODO: call api
      await getuserConfirm({
        variables: {
          orderBy: "createdAt_DESC",
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };


  return (
    <React.Fragment>
      <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            padding: "20px",
            height: "100vh",
            overflow: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#3C169B",
            }}
          >
            <span style={{ fontSize: "24px", color: "#6B7280" }}>
              <ArrowBackIcon
                sx={{ fontSize: "30px", cursor: "pointer" }}
                onClick={() => history.goBack()}
              />
              &emsp; ຈັດການລູກຄ້າ({userconfirmTotal})
            </span>

          </div>

          {/* //!FILTER */}
          <div style={{display:'flex', width:'100%', justifyContent:'space-between', marginTop: 10}}>
            <Row>
              <Col xs={3}>
                {/* Search Input */}
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: "#E5E7EB",
                      border: "1px solid #D1D5DB",
                      borderRadius: "8px 0 0 8px",
                    }}>
                    <SearchIcon sx={{ color: "#6B7280" }} />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Search"
                    aria-describedby="search-input"
                    onChange={(e) => setSearchCustomer(e.target.value)}
                    value={searchCustomer}
                    style={{
                      border: "1px solid #D1D5DB",
                      borderLeft: "none",
                      borderRadius: "0 8px 8px 0",
                      backgroundColor: "#E5E7EB",
                      color: "#6B7280",
                    }}
                  />
                </InputGroup>
              </Col>
              <Col xs={3}>
                {/* Select Dropdown */}
                <div style={{ flex: 1 }}>
                  {getUserTypeLoading || _.isEmpty(newUserTypeData) ? (
                    <p style={{ margin: 0, color: "#6B7280" }}>Loading...</p>
                  ) : (
                    <Form.Select
                      name="userType"
                      onChange={(e) => setSelectUserType(e.target.value)}
                      value={selectUserType}
                      style={{
                        border: "1px solid #D1D5DB",
                        borderRadius: "8px",
                        backgroundColor: "#E5E7EB",
                        color: "#6B7280",
                      }}
                      aria-label="Default select example">
                      <option value="">
                        ປະເພດລູກຄ້າ...
                      </option>
                      {newUserTypeData.map((i) => (
                        <option key={i?.id} value={i?.id}>
                          {i?.name}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </div>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="date"
                  onChange={(e) => setSelectedDate((p) => ({ ...p, start: e.target.value }))}
                  value={selectedDate.start}
                  style={{
                    border: "1px solid #D1D5DB",
                    borderLeft: "none",
                    borderRadius: "8px",
                    backgroundColor: "#E5E7EB",
                    color: "#6B7280",
                  }}
                />
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="date"
                  onChange={(e) => setSelectedDate((p) => ({ ...p, end: e.target.value }))}
                  value={selectedDate.end}
                  style={{
                    border: "1px solid #D1D5DB",
                    borderLeft: "none",
                    borderRadius: "8px",
                    backgroundColor: "#E5E7EB",
                    color: "#6B7280",
                  }}
                />
              </Col>
            </Row>
            <div style={{ display: "flex" }}>
              <CustomButton
                width="165px"
                height="46px"
                title="ເພີ່ມລູກຄ້າ"
                icon={<ReactIcons.MdAdd />}
                borderRadius="8px"
                onClick={() => {
                  setActionMode({
                    mode: false,
                    open: true,
                    data: null,
                  });
                }}
              />
              &nbsp;
              <CustomButton
                width="165px"
                height="46px"
                marginTop="2px"
                title="ຈັດການປະເພດລູກຄ້າ"
                borderRadius="8px"
                onClick={() => setUserTypeModal(true)}
              />
            </div>
          </div>

          {/* table */}
          {loading && !getuserConfirmData ? (
            <AnimationLoading />
          ) : (
            <>
              {userConfirm?.length > 0 ? (
                <Table
                  responsive
                  style={{
                    marginTop: 5,
                    borderCollapse: "collapse",
                    width: "100% ",
                  }}
                >
                  <thead
                    style={{
                      background:
                        "#1F3A60",
                      borderRadius: " 8px 8px 0px 0px",
                      color: "#FFFFFF",
                    }}
                  >
                    <tr>
                      <th>#</th>
                      <th>ໄອດີລູກຄ້າ</th>
                      <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                      <th>ເພດ</th>
                      <th>ເບີໂທ</th>
                      <th>ບ້ານ</th>
                      <th>ເມືອງ</th>
                      <th>ແຂວງ</th>
                      <th>ວັນທີ</th>
                      <th>ປະເພດ</th>
                      <th>ຄະແນນປັດຈຸບັນ</th>
                      <th>ຄະແນນທັງໝົດ</th>
                      <th>ຈັດການ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userConfirm?.map((user, index) => (
                      <tr key={index}>
                        <td style={{ paddingTop: "1rem" }}>
                          {index + 1 + _limit * (_skip - 1)}
                        </td>
                        <td style={{ paddingTop: "1rem" }}>
                          {user?.userCode ?? "-"}
                        </td>
                        <td style={{ paddingTop: "1rem" }}>
                          {user?.name ?? "-"} {user?.lastname ?? "-"}
                        </td>
                        <td style={{ paddingTop: "1rem" }}>
                          {" "}
                          {(user?.gender === "MALE" || user?.gender === "male") ? "ຊາຍ" : "ຍິງ"}
                        </td>
                        <td style={{ paddingTop: "1rem" }}>
                          <p>{user?.phone}</p>
                        </td>
                        <td style={{ paddingTop: "1rem" }}>
                          {user?.address?.village ?? "-"}
                        </td>
                        <td style={{ paddingTop: "1rem" }}>
                          {user?.address?.district ?? "-"}
                        </td>
                        <td style={{ paddingTop: "1rem" }}>
                          {user?.address?.province ?? "-"}
                        </td>
                        <td style={{ paddingTop: "1rem" }}>
                          {" "}{moment(user?.createdAt).format("DD/MM/YYYY")}{" "}
                        </td>
                        <td
                          style={{ paddingTop: "1rem", background: "#F1F0E8" }}
                        >
                          {" "}{user?.userType?.name ?? "-"}{" "}
                        </td>
                        <td
                          style={{ paddingTop: "1rem"}}
                        >
                          {" "}{user?.currentPoint ?? "-"}{" "}
                        </td>
                        <td
                          style={{ paddingTop: "1rem"}}
                        >
                          {" "}{user?.totalPoint ?? "-"}{" "}
                        </td>

                        <td style={{ paddingTop: "1rem" }}>
                          <td style={{ width: "30%" }}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <CustomButton
                                width="80px"
                                height="42px"
                                borderRadius="8px"
                                textalign="center"
                                border="1px solid #3C169B"
                                title="ເເກ້ໄຂ້"
                                color="#3C169B"
                                background="#F7F7F7"
                                onClick={() => {
                                  setActionMode({
                                    mode: true,
                                    open: true,
                                    data: user,
                                  });
                                }}
                              />
                              &ensp;
                              <CustomButton
                                width="50px"
                                height="42px"
                                margin="0"
                                title=" ລົບ"
                                border="1px solid #DC2626"
                                borderRadius="8px"
                                background="#F7F7F7"
                                color="#DC2626"
                                onClick={() =>
                                  handleShowDelete(user?.id, user?.name)
                                }
                              />
                            </div>
                          </td>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div>
                  {userConfirm?.length <= 0 && (
                    <div
                      style={{
                        fontSize: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#6B7280",
                        fontWeight: "400",
                      }}
                    >
                      <EmptyComponent />
                      <p>ຍັງບໍ່ມີລູກຄ້າກະລຸນາໄປເພີ່ມລູກຄ້າກ່ອນ !!!</p>
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          {/* end table */}
          {userconfirmTotal > 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              {userconfirmTotal && (
                <div className="show">
                  ກຳລັງສະແດງ {50 * _skip - 49}-
                  {50 * _skip > userconfirmTotal
                    ? userconfirmTotal
                    : 50 * _skip}{" "}
                  ຈາກ {userconfirmTotal}
                </div>
              )}
              <div>{Pagination_helper(userconfirmTotal, "", ``)}</div>
              <div></div>
              <div />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>

      {/* create Unit */}
      <Modal show={actionMode.open} onHide={() => cleanAction()}>
        <Modal.Header closeButton>
          <Modal.Title>{actionMode.mode ? "ແກ້ໄຂ້ລູກຄ້າ" : "ເພີ່ມລູກຄ້າ"}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            name: actionMode?.data?.name ?? '',
            lastname: actionMode?.data?.lastname ?? '',
            userCode: actionMode?.data?.userCode ?? "",
            gender: actionMode?.data?.gender ?? "MALE",
            phone: actionMode?.data?.phone ?? "",
            address: {
              village: actionMode?.data?.address?.village ?? "",
              province: actionMode?.data?.address?.province ?? "",
              district: actionMode?.data?.address?.district ?? "",
            },
            userType: actionMode?.data?.userType?.id ?? editUserType ?? ''
          }}
          
          onSubmit={(values) => {
            actionMode?.mode ? _updateUerConfirm(values) : _createUser(values);
          }}
        >
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <>
              <Modal.Body>
                <div className="row">
                  <div className="col-6">
                    <Form.Label>ຊື່</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      placeholder="ປອ້ນຊື່..."
                    />
                  </div>
                  <div className="col-6">
                    <Form.Label>ນາມສະກຸນ</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.lastname}
                      placeholder="ນາມສະກຸນ..."
                    />
                  </div>
                </div>
                <Form.Group className="my-2">
                  <Form.Label style={{ opacity: 0.7 }}>ໄອດີລູກຄ້າ</Form.Label>
                  <Form.Control
                    type="text"
                    name="userCode"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.userCode}
                  /> 
                </Form.Group>
                <br />
                <div className="row">
                  <div className="col-6">
                    <Form.Label>ເບີໂທ</Form.Label>
                    <Form.Control
                      type="number"
                      name="phone"
                      maxLength={8}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.phone}
                      placeholder="ເບີໂທ 8 ໂຕເລກ..."
                    />
                  </div>
                  <div className="col-6">
                    <Form.Label>ເພດ</Form.Label>
                    <Form.Select
                      name="gender"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.gender}
                      aria-label="Default select example"
                    >
                      <option>ເລືອກເພດ</option>
                      <option value="MALE">ຊາຍ</option>
                      <option value="FEMALE">ຍິງ</option>
                    </Form.Select>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-6">
                    <Form.Label>ເເຂວງ</Form.Label>
                    <Form.Select
                      name="address.province"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.address?.province}
                      aria-label="Default select example"
                    >
                      <option value="">---ເລືອກແຂວງ---</option>
                      {LaoAddress.map((p, index) => (
                        <option
                          key={"province" + index}
                          value={p?.province_name}
                        >
                          {p?.province_name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="col-6">
                    <Form.Label>ເມືອງ</Form.Label>
                    <Form.Select
                      name="address.district"
                      disabled={!values?.address?.province}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.address?.district}
                      aria-label="Default select example"
                    >
                      <option value="">---ເລືອກເມືອງ---</option>
                      {values?.address?.province &&
                        LaoAddress.filter(
                          (f) => f.province_name === values?.address?.province
                        )[0].district_list.map((p, index) => (
                          <option key={"district" + index} value={p?.district}>
                            {p?.district}
                          </option>
                        ))}
                    </Form.Select>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-6">
                    <Form.Label>ບ້ານ</Form.Label>
                    <Form.Control
                      type="text"
                      name="address.village"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.address?.village}
                      placeholder="ປອ້ນບ້ານ..."
                    />
                  </div>
                  <div className="col-6">
                    <Form.Label>ປະເພດລູກຄ້າ</Form.Label>
                    {getUserTypeLoading ||
                      _.isEmpty(getUserTypeData?.getUserTypes) ? (
                      <p>User typing...</p>
                    ) : (
                      <Form.Select
                        name="userType"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.userType}
                        required
                        aria-label="Default select example"
                      >
                        {getUserTypeData?.getUserTypes
                          .filter((item) => item?.isOpen)
                          .map((i) => (
                            <option key={i?.id} value={i?.id}>
                              {i?.name}
                            </option>
                          ))}
                      </Form.Select>
                    )}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <CustomButton
                  title="ຍົກເລີກ"
                  width="100px"
                  background="#A9B3BD"
                  borderRadius="8px"
                  onClick={() => cleanAction()}
                />
                &emsp;
                <CustomButton
                  title={loadingCreate ? <Spinner /> : "ບັນທຶກ"}
                  width="100px"
                  borderRadius="8px"
                  onClick={() => handleSubmit()}
                />
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>

      {/* end delete modal */}

      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={_confirmeDelete}
        title="ແຈ້ງເຕືອນ"
        text={`ທ່ານຕອ້ງການລົບຂໍ້ມູນ ${Delete?.name} ນີ້ເເທ້ບໍ່!`}
      />

      {/* //TODO ປະເພດລູກຄ້າ */}
      <Modal
        centered
        show={userTypeModal}
        onHide={() => setUserTypeModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>ຈັດການປະເພດລູກຄ້າ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserTypeManage />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
